module.exports = __webpack_public_path__ + "img/Teaching-Research Case - White.ec1e00ac.png";